import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { logout } from "../services/api";

const navItems = [
  { to: "/",           label: "Dashboard",   icon: "📊" },
  { to: "/employees",  label: "Mitarbeiter", icon: "👥" },
  { to: "/sync",       label: "Synchronisation", icon: "🔄" },
  { to: "/contacts",   label: "Kontakte",    icon: "📇" },
  { to: "/drucker",    label: "Drucker",     icon: "🖨️" },
  { to: "/logs",       label: "Protokoll",   icon: "📋" },
  { to: "/settings",   label: "Einstellungen", icon: "⚙️" },
];

export default function Layout({ user, setUser, children }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    setUser(null);
    navigate("/");
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar */}
      <aside style={{
        width: 220, background: "#1a1a2e", color: "white",
        display: "flex", flexDirection: "column", position: "fixed",
        top: 0, left: 0, height: "100vh", zIndex: 10
      }}>
        <div style={{ padding: "24px 20px 16px", borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
          <div style={{ fontSize: 13, opacity: 0.6, marginBottom: 4 }}>freestyle</div>
          <div style={{ fontSize: 18, fontWeight: 700 }}>Mitarbeiter</div>
          <div style={{ fontSize: 18, fontWeight: 700, color: "#0078d4" }}>Verwaltung</div>
        </div>

        <nav style={{ flex: 1, padding: "12px 0" }}>
          {navItems.map(({ to, label, icon }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              style={({ isActive }) => ({
                display: "flex", alignItems: "center", gap: 10,
                padding: "10px 20px", color: "white", textDecoration: "none",
                background: isActive ? "rgba(0,120,212,0.3)" : "transparent",
                borderLeft: isActive ? "3px solid #0078d4" : "3px solid transparent",
                transition: "background 0.15s",
              })}
            >
              <span>{icon}</span>
              <span style={{ fontSize: 14 }}>{label}</span>
            </NavLink>
          ))}
        </nav>

        {/* User Info */}
        <div style={{ padding: "16px 20px", borderTop: "1px solid rgba(255,255,255,0.1)" }}>
          <div style={{ fontSize: 12, opacity: 0.6 }}>Angemeldet als</div>
          <div style={{ fontSize: 13, marginTop: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {user.name}
          </div>
          <div style={{ fontSize: 11, opacity: 0.5, marginBottom: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {user.email}
          </div>
          <button
            onClick={handleLogout}
            style={{ width: "100%", padding: "6px 0", background: "rgba(255,255,255,0.1)", color: "white", borderRadius: 4, border: "none", cursor: "pointer", fontSize: 13 }}
          >
            Abmelden
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main style={{ marginLeft: 220, flex: 1, padding: 28, background: "#f0f2f5", minHeight: "100vh" }}>
        {children}
      </main>
    </div>
  );
}
